import React from "react";
import { Card } from "react-bootstrap";
import EditableText from "../../../Docuclipper/EditableText";
import { ReduxState } from "../../../../redux";
import {
  TemplateFieldV2,
  Fragment,
} from "../../../../docuclipper/DocuclipperTypes";
import { useDispatch, useSelector } from "react-redux";
import { updateFragmentFn } from "../../../../redux/reducers/TemplateField";
import TrackedButton from "../../../Docuclipper/TrackedButton";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { withSelectedField } from "./withSelectedField";
import { withSelectedFragment } from "./withSelectedFragment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import uuidv4 from "uuid/v4";
import { FlagBadExtractionButton } from "../FlagBadExtractionButton";

type Props = {
  fragment: Fragment;
  field: TemplateFieldV2;
};
export const ExtractedDataText2: React.SFC<Props> = ({ fragment, field }) => {
  const { canvasMode, stage } = useSelector(
    (state: ReduxState) => state.TemplateField
  );

  const dispatch = useDispatch();

  const initialText =
    fragment.editedText || fragment.improvedText || fragment.extractedText;

  const [text, setText] = React.useState(initialText);

  React.useEffect(() => {
    const text =
      fragment.editedText || fragment.improvedText || fragment.extractedText;

    setText(text);
  }, [fragment.editedText, fragment.improvedText, fragment.extractedText]);

  const onFieldUpdate = (text: string) => {
    dispatch(
      updateFragmentFn({
        text,
        id: field.id,
        fragmentId: fragment.id,
      })
    );
  };

  return (
    <>
      <Card style={{ width: "100%" }}>
        <Card.Header>
          <OverlayTrigger
            popperConfig={{
              modifiers: {
                preventOverflow: {
                  enabled: false,
                },
              } as any,
            }}
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={(props) => (
              <Tooltip id="copyToClipboardTooltip" {...props}>
                Copy text to clipboard
              </Tooltip>
            )}
          >
            <CopyToClipboard text={text}>
              <TrackedButton
                action="copyTextClick"
                variant="link"
                className="btn--copy-to-clipboard"
              >
                <FontAwesomeIcon icon="copy" />
                <span className="ml-1">Copy text</span>
              </TrackedButton>
            </CopyToClipboard>
          </OverlayTrigger>
        </Card.Header>
        <Card.Body
          className="div--extracted-data-text"
          style={{ overflowY: "scroll" }}
        >
          <div
            style={{
              position: "relative",
              maxHeight: stage
                ? `${
                    stage.height *
                    (canvasMode === "viewExtractedData" ? 0.9 : 0.2)
                  }px`
                : "500px",
            }}
          >
            {canvasMode === "viewExtractedData" && (
              <EditableText
                key={uuidv4()}
                initialValue={text}
                onConfirm={onFieldUpdate}
              />
              // <span>{text}</span>
            )}
            {canvasMode !== "viewExtractedData" && <span>{text}</span>}
          </div>
          <div style={{ position: "absolute", bottom: 0, right: 0 }}>
            <FlagBadExtractionButton />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
export const ExtractedDataText = withSelectedField(
  withSelectedFragment(ExtractedDataText2)
);
